module.exports = __webpack_public_path__ + "static/img/obj7.ed6e2038.png";